export function parseCssVariables(selector = ':root') {
  const cssVars = {};
  [...document.styleSheets]
    .filter(
      ({ href }) => href === null || href.startsWith(window.location.origin)
    )
    .reduce((prev, styleSheet) => {
      return (
        prev +
        [...styleSheet.cssRules].forEach(cssRule => {
          if (cssRule.selectorText !== selector) {
            return;
          }

          cssRule.cssText
            .split('{')[1]
            .replace('}', '')
            .split(';')
            .map(i => i.replace(/\s+/g, '').split(':'))
            .forEach(([key, value]) => {
              if (!key.startsWith('--')) {
                return;
              }

              cssVars[key] = value;
            });
        })
      );
    }, '');

  return cssVars;
}

export default parseCssVariables;
